/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListRemoteMcpServersSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListRemoteMcpServersSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListRemoteMcpServersSecurity = {
  option1?: ListRemoteMcpServersSecurityOption1 | undefined;
  option2?: ListRemoteMcpServersSecurityOption2 | undefined;
};

export type ListRemoteMcpServersRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListRemoteMcpServersSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListRemoteMcpServersSecurityOption1$outboundSchema: z.ZodMiniType<
  ListRemoteMcpServersSecurityOption1$Outbound,
  ListRemoteMcpServersSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listRemoteMcpServersSecurityOption1ToJSON(
  listRemoteMcpServersSecurityOption1: ListRemoteMcpServersSecurityOption1,
): string {
  return JSON.stringify(
    ListRemoteMcpServersSecurityOption1$outboundSchema.parse(
      listRemoteMcpServersSecurityOption1,
    ),
  );
}

/** @internal */
export type ListRemoteMcpServersSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListRemoteMcpServersSecurityOption2$outboundSchema: z.ZodMiniType<
  ListRemoteMcpServersSecurityOption2$Outbound,
  ListRemoteMcpServersSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listRemoteMcpServersSecurityOption2ToJSON(
  listRemoteMcpServersSecurityOption2: ListRemoteMcpServersSecurityOption2,
): string {
  return JSON.stringify(
    ListRemoteMcpServersSecurityOption2$outboundSchema.parse(
      listRemoteMcpServersSecurityOption2,
    ),
  );
}

/** @internal */
export type ListRemoteMcpServersSecurity$Outbound = {
  Option1?: ListRemoteMcpServersSecurityOption1$Outbound | undefined;
  Option2?: ListRemoteMcpServersSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListRemoteMcpServersSecurity$outboundSchema: z.ZodMiniType<
  ListRemoteMcpServersSecurity$Outbound,
  ListRemoteMcpServersSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListRemoteMcpServersSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListRemoteMcpServersSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listRemoteMcpServersSecurityToJSON(
  listRemoteMcpServersSecurity: ListRemoteMcpServersSecurity,
): string {
  return JSON.stringify(
    ListRemoteMcpServersSecurity$outboundSchema.parse(
      listRemoteMcpServersSecurity,
    ),
  );
}

/** @internal */
export type ListRemoteMcpServersRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListRemoteMcpServersRequest$outboundSchema: z.ZodMiniType<
  ListRemoteMcpServersRequest$Outbound,
  ListRemoteMcpServersRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listRemoteMcpServersRequestToJSON(
  listRemoteMcpServersRequest: ListRemoteMcpServersRequest,
): string {
  return JSON.stringify(
    ListRemoteMcpServersRequest$outboundSchema.parse(
      listRemoteMcpServersRequest,
    ),
  );
}
